export enum CreatorStreamState {
  Idle = "IDLE",
  Starting = "STARTING",
  Stopping = "STOPPING",
  Running = "RUNNING",
}
